import request from '../../request'

export default {
    actions:{
        getSaleReport(_, payload) {
            return request.get('sales-reports', {
                params: payload,
            });
        },
        getServiceReport(_, payload) {
            return request.get('services-reports', {
                params: payload,
            });
        },
        getIncomeExpensesReport(_, payload) {
            return request.get('incomeexpenses-reports', {
                params: payload,
            });
        },
        getEmployeeReports(_,payload){
            return request.get('employee-reports',{
                params:payload
            })
        }
    }
}